const t10s = translations => {
	const _t10s = translations || {};
	const bracketMatcher = new RegExp('\\[\\[.*?]]', 'g');
	const curlyMatcher = new RegExp('{{.*?}}', 'g');

	const getPhrase = key => {
		return _t10s[key] || key || '';
	};

	const replace = (phrase, matcher, replacements) => {
		return phrase.replace(matcher, function (match) {
			const key = match.replace('{{', '').replace('}}', '').replace('[[', '').replace(']]', '');
			return replacements[key] || match;
		});
	};

	return {
		translate: (key, replacements) => {
			let phrase = getPhrase(key);
			if (replacements) {
				phrase = replace(phrase, bracketMatcher, replacements);
				phrase = replace(phrase, curlyMatcher, replacements);
			}

			return phrase;
		}
	};
};

export default t10s;
